import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  novoLocal: {
    backgroundColor: '#F7C331', 
    color: 'white',
    fontWeight: 'bold',
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  item: {
    marginTop: theme.spacing(1),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  addIcon: {
    marginRight: '5px',
  }

}))

export default useStyles